<template>
  <v-card class="pa-2">
    <v-flex xs12 sm12 md8 pa-1 style="margin-right: auto;margin-left: auto;">
      <v-icon medium>
        assignment_ind0
      </v-icon>
      <span class="title font-weight-light">Informações do Aluno</span>
    </v-flex>
    <br>
    <v-layout wrap>
      <v-flex xs12 sm12 md12>
        <v-img :src="getFotoAluno" aspect-ratio="1.01" max-width="280" style="border-radius: 400px; margin-left: auto; margin-right: auto" />
      </v-flex>
      <v-flex xs12 sm12 md12>
        <br>
        <v-card-text>
          <v-layout column wrap>
            <v-flex>
              <v-layout wrap>
                <v-flex xs12 sm12 md8 pa-1 style="margin-right: auto;margin-left: auto;">
                  <v-text-field
                    v-model="aluno.nome"
                    label="Nome do aluno"
                    outlined
                    readonly
                  />
                </v-flex>
                <v-flex xs12 sm12 md8 pa-1 style="margin-right: auto;margin-left: auto;">
                  <v-text-field
                    v-model="aluno.cpf"
                    label="CPF do aluno"
                    outlined
                    readonly
                  />
                </v-flex>
                <v-flex xs12 sm12 md8 pa-1 style="margin-right: auto;margin-left: auto;">
                  <v-text-field
                    v-model="aluno.renach"
                    label="Renach do aluno"
                    outlined
                    readonly
                  />
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-flex>
    </v-layout>
  </v-card>
</template>
<script>
export default {
  components: {
  },
  data() {
    return {
      mask_cpf: '###.###.###-##',
      mask_renach: '###.###.###',
      terminado: true,
      alerts: {
        show: true,
        items: [],
      },
      dialog: {
        title: 'Baixando informações',
        message: 'Aguarde carregando...',
      },
      aluno: {},
      token: null,
    };
  },
  computed: {
    getFotoAluno() {
      const image = this.$store.getters.getAluno.foto;

      if (image) {
        return `data:image/png;base64, ${image}`;
      }

      return require('../../assets/icon_user.png');
    }
  },
  created() {
    this.getAluno();
  },
  methods: {
    mountAlerts(classType, msg) {
      this.alerts.items.push({classType, msg});
    },
    getAluno() {
      this.aluno = this.$store.getters.getAluno;
    },
  },
};
</script>
